import { Col, Radio, Row, Input, Form as AntForm } from 'antd';
import styled from 'styled-components';
import { HSMSTypography } from '@components/shared/HSMSTypography';
import React from 'react';
import { exit_interview_answerQuery } from '@app-types/graphql-types';

const { Item: FormItem } = AntForm;
const { TextArea } = Input;

interface QuestionProps {
  type: string;
  name: string;
  id: string;
}

interface QuestionGroupProps {
  name: string;
  questions: QuestionProps[];
}

interface HSMSRadioGroupQuestionProps {
  questionGroup?: QuestionGroupProps;
  onCheck?: (e, questionId, questionType) => void;
  exitInterviewAnswers?: exit_interview_answerQuery['exit_interview_answer'];
}

const CustomRadioGroup = styled(Radio.Group)`
  width: 100%;
`;

const QuestionContainer = styled.div`
  padding: 1.2rem;
`;

const Container = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const HSMSRadioGroupQuestion = ({
  questionGroup,
  onCheck,
  exitInterviewAnswers,
}: HSMSRadioGroupQuestionProps) => {
  const checkRateAnswer = (questionId) => {
    const questionAnswer = exitInterviewAnswers?.filter((answer) => answer?.questionId === questionId);
    if (questionAnswer?.length > 0) {
      return questionAnswer[0]?.rateAnswer;
    }
    return null;
  };

  const checkTextAnswer = (questionId) => {
    const questionAnswer = exitInterviewAnswers?.filter((answer) => answer?.questionId === questionId);
    if (questionAnswer?.length > 0) {
      return questionAnswer[0]?.textAnswer;
    }
    return null;
  };

  return (
    <Container>
      <HSMSTypography strong>{questionGroup.name}</HSMSTypography>
      <QuestionContainer>
        <Row gutter={[0, 16]}>
          <Col md={12} lg={12} />
          <Col md={3} lg={3}>
            <HSMSTypography strong>Strongly Disagree</HSMSTypography>
          </Col>
          <Col md={3} lg={3}>
            <HSMSTypography strong>Disagree</HSMSTypography>
          </Col>
          <Col md={3} lg={3}>
            <HSMSTypography strong>Agree</HSMSTypography>
          </Col>
          <Col md={3} lg={3}>
            <HSMSTypography strong>Strongly Agree</HSMSTypography>
          </Col>

          {questionGroup.questions.map((question) => {
            if (question.type === 'rate') {
              return (
                <>
                  <Col md={12} lg={12}>
                    <FormItem label={question.name} required />
                  </Col>

                  <Col md={12} lg={12}>
                    {exitInterviewAnswers ? (
                      <CustomRadioGroup
                        value={exitInterviewAnswers && checkRateAnswer(question.id)}
                        onChange={(e) => onCheck(e, question.id, question.type)}
                      >
                        <Row>
                          <Col md={6} lg={6}>
                            <Radio value={1} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={2} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={3} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={4} />
                          </Col>
                        </Row>
                      </CustomRadioGroup>
                    ) : (
                      <CustomRadioGroup onChange={(e) => onCheck(e, question.id, question.type)}>
                        <Row>
                          <Col md={6} lg={6}>
                            <Radio value={1} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={2} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={3} />
                          </Col>
                          <Col md={6} lg={6}>
                            <Radio value={4} />
                          </Col>
                        </Row>
                      </CustomRadioGroup>
                    )}
                  </Col>
                </>
              );
            }
            return <></>;
          })}
        </Row>
        <Row>
          {questionGroup.questions.map((question) => {
            if (question.type === 'text') {
              return (
                <>
                  <Col md={24} lg={24}>
                    <FormItem label={question.name} required />
                  </Col>
                  {exitInterviewAnswers ? (
                    <Col md={12} lg={24}>
                      <TextArea
                        rows={4}
                        onChange={(event) => onCheck(event, question.id, question.type)}
                        value={exitInterviewAnswers && checkTextAnswer(question.id)}
                      />
                    </Col>
                  ) : (
                    <Col md={12} lg={24}>
                      <TextArea rows={4} onChange={(event) => onCheck(event, question.id, question.type)} />
                    </Col>
                  )}
                </>
              );
            }
            return null;
          })}
        </Row>
      </QuestionContainer>
    </Container>
  );
};
